const expiration = new Date();
expiration.setTime(new Date().getTime() + 120000);

const SearchSSR = [
  {
    tag: 'title',
    content: 'Busca - Canaltech',
  },
  {
    tag: 'link',
    attr: {
      rel: 'image_src',
      href: 'https://img.canaltech.com.br/canaltech-512.png',
    },
  },
  {
    tag: 'meta',
    attr: {
      property: 'og:image',
      content: 'https://img.canaltech.com.br/canaltech-512.png',
    },
  },
  {
    tag: 'meta',
    attr: {
      name: 'twitter:image',
      content: 'https://img.canaltech.com.br/canaltech-512.png',
    },
  },
  {
    tag: 'meta',
    attr: {
      name: 'image',
      content: 'https://img.canaltech.com.br/canaltech-512.png',
    },
  },
  {
    tag: 'link',
    attr: {
      rel: 'chrome-webstore-item',
      href: 'https://chrome.google.com/webstore/detail/aaheckeofbchahoglpgjmengoeggpcid',
    },
  },
  {
    tag: 'link',
    attr: {
      rel: 'canonical',
      href: 'https://canaltech.com.br/busca/',
    },
  },
  {
    tag: 'meta',
    attr: {
      property: 'og:url',
      content: 'https://canaltech.com.br/busca/',
    },
  },
  {
    tag: 'meta',
    attr: {
      property: 'og:site_name',
      content: 'Canaltech',
    },
  },
  {
    tag: 'meta',
    attr: {
      property: 'fb:app_id',
      content: '444793475548724',
    },
  },
  {
    tag: 'meta',
    attr: {
      property: 'fb:pages',
      content: '264439246937821',
    },
  },
  {
    tag: 'meta',
    attr: {
      property: 'og:locale',
      content: 'pt_BR',
    },
  },
  {
    tag: 'meta',
    attr: {
      name: 'apple-itunes-app',
      content: 'app-id=1005606952',
    },
  },
  {
    tag: 'meta',
    attr: {
      name: 'google-play-app',
      content: 'app-id=br.com.canaltech',
    },
  },
  {
    tag: 'meta',
    attr: {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  },
  {
    tag: 'meta',
    attr: {
      name: 'twitter:site',
      content: '@canaltech',
    },
  },
  {
    tag: 'meta',
    attr: {
      name: 'twitter:creator',
      content: '@canaltech',
    },
  },
  {
    tag: 'meta',
    attr: {
      name: 'twitter:domain',
      content: '[canaltech.com.br](http://canaltech.com.br/)',
    },
  },
  {
    tag: 'meta',
    attr: {
      name: 'revisit-after',
      content: '1 days',
    },
  },
  {
    tag: 'meta',
    attr: {
      name: 'resource-type',
      content: 'document',
    },
  },
  {
    tag: 'meta',
    attr: {
      name: 'distribution',
      content: 'global',
    },
  },
  {
    tag: 'meta',
    attr: {
      name: 'rating',
      content: 'general',
    },
  },
  {
    tag: 'meta',
    attr: {
      name: 'robots',
      content: 'noindex, follow',
    },
  },
  {
    tag: 'meta',
    attr: {
      name: 'title',
      content: 'Busca - Canaltech',
    },
  },
  {
    tag: 'meta',
    attr: {
      property: 'og:title',
      content: 'Busca - Canaltech',
    },
  },
  {
    tag: 'meta',
    attr: {
      name: 'twitter:title',
      content: 'Busca - Canaltech',
    },
  },
  {
    tag: 'meta',
    attr: {
      'http-equiv': 'Cache-control',
      content: 'max-age=120, stale-while-revalidate=120',
    },
  },
  {
    tag: 'meta',
    attr: {
      name: 'Expires',
      content: expiration.toUTCString(),
    },
  },
];

export default SearchSSR;
